import { FC } from 'react'
import RiskMemberMultilineFields from '@templates/RiskMemberMultilineFields'
import RiskMapStatuses from '@enums/RiskMapStatuses'
import DivisionFields from './DivisionFields'
import InfoFields from './InfoFields'

type Props = {
  status: RiskMapStatuses | undefined
  isEdit: boolean
}

const MainRisks: FC<Props> = ({ status, isEdit }) => {
  const notDraft = isEdit && status !== RiskMapStatuses.DRAFT

  return (
    <div>
      <DivisionFields isDisabled={notDraft} isEdit={isEdit} />
      <InfoFields fileDisabled={notDraft} isEdit={isEdit} status={status} />
      <RiskMemberMultilineFields />
    </div>
  )
}

export default MainRisks
